import {createLock, Lock} from './lock';

/*
 * State.
 */

// We would use a WeakMap so these locks can be GC'ed, but WeakMaps don't support string keys.
const globalLocks = new Map<string, Lock>();

/*
 * API.
 */

export function findGlobalLock(key: string): Lock {
  const existingLock = globalLocks.get(key);
  if (existingLock) {
    return existingLock;
  }

  const newLock = createLock();
  globalLocks.set(key, newLock);
  return newLock;
}

/** Used to safely reset global locks after a test. */
export function resetGlobalLocks() {
  try {
    // Make sure the test has properly cleaned up all asynchronous work.
    globalLocks.forEach((lock, key) => {
      if (lock.isLocked) {
        throw new Error(`Global lock "${key}" is still locked`);
      }
    });
  } finally {
    // Leave things clean regardless.
    globalLocks.clear();
  }
}
